/**
 * Componente de Seleção de Parceiro
 * Útil para testes e demonstrações
 */

import React, { useState } from 'react';
import { listParceiros, switchParceiro, getActiveParceiro } from '../../data/parceiros';
import styles from './ParceiroBranding.module.css';

const ParceiroBranding = () => {
  const [parceiroAtivo] = useState(getActiveParceiro());
  const parceiros = listParceiros();

  const handleSwitch = (parceiroId) => {
    if (window.confirm(`Trocar para ${parceiroId}? A página será recarregada.`)) {
      switchParceiro(parceiroId);
    }
  };

  return (
    <div className={styles.container}>
      <h3>🎨 Seletor de Branding</h3>
      <p className={styles.info}>
        <strong>Parceiro Ativo:</strong> {parceiroAtivo}
      </p>
      
      <div className={styles.parceirosList}>
        {parceiros.map(parceiro => (
          <div 
            key={parceiro.id} 
            className={`${styles.parceiroCard} ${parceiro.id === parceiroAtivo ? styles.active : ''}`}
          >
            <div className={styles.parceiroInfo}>
              <h4>{parceiro.name}</h4>
              <p className={styles.domain}>{parceiro.domain || 'N/A'}</p>
              <span className={`${styles.status} ${parceiro.active ? styles.statusActive : styles.statusInactive}`}>
                {parceiro.active ? '✓ Ativo' : '✗ Inativo'}
              </span>
            </div>
            
            {parceiro.id !== parceiroAtivo && (
              <button 
                className={styles.switchBtn}
                onClick={() => handleSwitch(parceiro.id)}
              >
                Trocar
              </button>
            )}
            
            {parceiro.id === parceiroAtivo && (
              <span className={styles.currentBadge}>Em Uso</span>
            )}
          </div>
        ))}
      </div>

      <div className={styles.instructions}>
        <h4>💡 Métodos de Ativação:</h4>
        <ul>
          <li><code>REACT_APP_PARTNER=telecomplus</code> (variável de ambiente)</li>
          <li><code>telecomplus.seudominio.com</code> (subdomínio)</li>
          <li>Use este seletor (salva no localStorage)</li>
        </ul>
      </div>
    </div>
  );
};

export default ParceiroBranding;
